import { theme } from "../../../../styles";

export const isMobile = ():boolean => (window.innerWidth <= theme.mediaQueryConstants.phone);
export const isTinyMobile = ():boolean => (window.innerWidth <= theme.mediaQueryConstants.phoneTiny);
export const isLowHeight = ():boolean => (window.innerHeight <= theme.mediaQueryConstants.lowHeight);
export const isVeryLowHeight = ():boolean => (window.innerHeight <= theme.mediaQueryConstants.veryLowHeight);

export const getRandomCharacters = (characters:string, num:number) => {
  let randomChars = '';
  const charLength = characters.length;

  for (let i = 0; i < num; i++) {
    randomChars += characters.charAt(Math.floor(Math.random() * charLength));
  };

  return randomChars;
}